import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TPostThirdAccountBindParams,
  TPostThirdAccountBindResponse,
  postThirdAccountBind,
  TPostThirdAccountUnbindParams,
  TPostThirdAccountUnbindResponse,
  postThirdAccountUnbind,
  TPostThirdAccountListParams,
  TPostThirdAccountListResponse,
  postThirdAccountList,
  TPostThirdAccountLoginParams,
  TPostThirdAccountLoginResponse,
  postThirdAccountLogin,
} from 'core/service/yapi/hk-web/ThirdAccount/api'
// 第三方账户接口
// 绑定第三方账户
export const usePostThirdAccountBindMutation = (
  mutationOptions?: TUseMutationOptions<TPostThirdAccountBindResponse, TPostThirdAccountBindParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['ThirdAccount', 'ThirdAccountBind', 'Post'],
    mutationFn: (params?: TPostThirdAccountBindParams) => postThirdAccountBind(params),
  })
}

// 解绑第三方账户
export const usePostThirdAccountUnbindMutation = (
  mutationOptions?: TUseMutationOptions<TPostThirdAccountUnbindResponse, TPostThirdAccountUnbindParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['ThirdAccount', 'ThirdAccountUnbind', 'Post'],
    mutationFn: (params?: TPostThirdAccountUnbindParams) => postThirdAccountUnbind(params),
  })
}

// 第三方账户绑定列表
export const usePostThirdAccountListMutation = (
  mutationOptions?: TUseMutationOptions<TPostThirdAccountListResponse, TPostThirdAccountListParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['ThirdAccount', 'ThirdAccountList', 'Post'],
    mutationFn: (params?: TPostThirdAccountListParams) => postThirdAccountList(params),
  })
}

// 第三方授权登录
export const usePostThirdAccountLoginMutation = (
  mutationOptions?: TUseMutationOptions<TPostThirdAccountLoginResponse, TPostThirdAccountLoginParams>
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['ThirdAccount', 'ThirdAccountLogin', 'Post'],
    mutationFn: (params?: TPostThirdAccountLoginParams) => postThirdAccountLogin(params),
  })
}
